var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowsInverted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9863 1.46967C11.2792 1.17678 11.754 1.17678 12.0469 1.46967L14.5301 3.95281C14.6707 4.09348 14.7498 4.28427 14.7497 4.4832C14.7497 4.68214 14.6707 4.87292 14.53 5.01356L12.0468 7.49584C11.7539 7.78869 11.279 7.7886 10.9862 7.49566C10.6933 7.20272 10.6934 6.72784 10.9864 6.435L12.939 4.48305L10.9863 2.53033C10.6934 2.23744 10.6934 1.76256 10.9863 1.46967Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 4.4856C1.25 4.07138 1.58579 3.7356 2 3.7356H14C14.4142 3.7356 14.75 4.07138 14.75 4.4856C14.75 4.89981 14.4142 5.2356 14 5.2356H2C1.58579 5.2356 1.25 4.89981 1.25 4.4856Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01356 8.50419C5.3064 8.79713 5.30632 9.272 5.01338 9.56485L3.06075 11.5168L5.01347 13.4695C5.30636 13.7624 5.30636 14.2373 5.01347 14.5302C4.72058 14.8231 4.2457 14.8231 3.95281 14.5302L1.46967 12.047C1.329 11.9064 1.24998 11.7156 1.25 11.5166C1.25002 11.3177 1.32907 11.1269 1.46976 10.9863L3.9529 8.504C4.24584 8.21116 4.72072 8.21124 5.01356 8.50419Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 11.5142C1.25 11.0999 1.58579 10.7642 2 10.7642H14C14.4142 10.7642 14.75 11.0999 14.75 11.5142C14.75 11.9284 14.4142 12.2642 14 12.2642H2C1.58579 12.2642 1.25 11.9284 1.25 11.5142Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowsInverted);
export default __webpack_public_path__ + "static/media/icon-arrows-inverted.54dba87f3be4ba995b6c22bf2ddfbe60.svg";
export { ForwardRef as ReactComponent };